'use strict'

import ruData from './../langs/ru.json'
import enData from './../langs/en.json'
import spData from './../langs/sp.json'

export default function ()
{
	const langs = this

	langs.list =
		{
			ru: ruData,
			en: enData,
			es: spData
		}

	langs.get = function ( lang )
		{
			if (lang === null) return []
			return langs.list[lang.toLowerCase()]
		}
}


// WEBPACK FOOTER //
// ./src/app/services/langs.service.js